import axios from "axios";
import { del, get, post, patch,  put } from "./course_components_api_helper";
import * as url from "./course_components_url_helper";





// Get features
export const getCourseComponents = () => get(url.GET_COURSE_COMPONENTS);



export const addNewCourseComponent = courseComponent => post(url.ADD_NEW_COURSE_COMPONENT, courseComponent);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateCourseComponent = courseComponent => patch(`${url.UPDATE_COURSE_COMPONENT}/${courseComponent.id}`,  courseComponent);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteCourseComponent = courseComponent => del(`${url.DELETE_COURSE_COMPONENT}/${courseComponent.id}`);







export {
  //getLoggedInUser,
  
  
};
